import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import UIbanner from "../Page-section/web-design-services/UIbanner";
import UIprocess from "../Page-section/web-design-services/UIprocess";
import { useSEO } from "../hooks/useSEO";

function UIUXDesign() {
  useSEO({
    title: "Professional Web Design Services for Business Growth",
    description:
      "Grow your business with professional web design services offering responsive layouts,SEO optimization, faster performance ,conversion-focused website solutions.",
    canonical: "https://empowerweb.in/web-design-services",
    ogTitle: "Professional Web Design Services | Boost Traffic & Increase Sales",
    ogDescription:
      "Looking for expert web design services? Get modern, mobile-friendly, and SEO-ready websites designed to increase leads, traffic, and online visibility.",
    keywords:
      "web design services,  web design company in india , website design company, responsive web design , ecommerce website design  ,ui ux design services ",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <UIbanner />
        <UIprocess />
      </main>
      <Footer />
     
    </div>
  );
}

export default UIUXDesign;
